import PublicRoutes from '../../../../routes/PublicRoutes';

// ------- FOR UNAUTHENTICATED/PUBLC FLOW --------
// Home for public routes. Any public route will go through this.
// Anything that needs to be done specifically for public routes can be done here.
const PublicHome = (): JSX.Element => {
  /*
  -- Uncomment to do stuff on mount
  useEffect(() => {
    async function handleUnauthMountInit() {

    }

    return () => {

    }
  }, []); */

  return <PublicRoutes />;
};

export default PublicHome;
